// Giả sử bạn đã cắt và lưu ảnh của từng nghệ sĩ vào public/artists/
import Artist from '../artist/artist';

const artistsData1 = [
  {
    src: '/assets/festival2025/vuon-concert-2025/images/artists-v2/minh-thuý-2.png',
    alt: 'Minh Thuý',
    titleSrc: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/titles/minh-thuy.png'
  },
  {
    src: '/assets/festival2025/vuon-concert-2025/images/artists-v2/hà-đức-tâm.png',
    alt: 'Hà Đức Tâm',
    titleSrc: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/titles/ha-duc-tam.png'
  },
  {
    src: '/assets/festival2025/vuon-concert-2025/images/artists-v2/la-moon.png',
    alt: 'La Moon',
    titleSrc: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/titles/la-moon.png'
  },
  {
    src: '/assets/festival2025/vuon-concert-2025/images/artists-v2/anh-tú.png',
    alt: 'Anh Tú',
    titleSrc: undefined // No title file available for this artist
  },
  {
    src: '/assets/festival2025/vuon-concert-2025/images/artists-v2/mỹ-tâm.png',
    alt: 'Mỹ Tâm - Ca sĩ chính',
    titleSrc: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/titles/my-tam.png'
  },
  {
    src: '/assets/festival2025/vuon-concert-2025/images/artists-v2/quan-a-p.png',
    alt: 'Quan A.P',
    titleSrc: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/titles/quan-a-p.png'
  },
  {
    src: '/assets/festival2025/vuon-concert-2025/images/artists-v2/thuỳ-chi.png',
    alt: 'Thuỳ Chi',
    titleSrc: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/titles/thuy-chi.png'
  },
  {
    src: '/assets/festival2025/vuon-concert-2025/images/artists-v2/thành-trung.png',
    alt: 'MC Thành Trung',
    titleSrc: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/titles/mc-thanh-trung.png'
  },
  {
    src: '/assets/festival2025/vuon-concert-2025/images/artists-v2/bé-xệ-xệ.png',
    alt: 'Bé Xệ Xệ',
    titleSrc: undefined // No title file available for this artist
  },
];

const artistsData = [
  {
    src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/minh-thuý-2.png',
    alt: 'Minh Thuý',
    titleSrc: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/titles/minh-thuy.png'
  },
  {
    src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/minh-thuý-2.png',
    alt: 'Minh Thuý',
    titleSrc: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/titles/minh-thuy.png'
  },
  {
    src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/minh-thuý-2.png',
    alt: 'Minh Thuý',
    titleSrc: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/titles/minh-thuy.png'
  },
  {
    src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/minh-thuý-2.png',
    alt: 'Minh Thuý',
    titleSrc: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/titles/minh-thuy.png'
  },
  {
    src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/mỹ-tâm.png',
    alt: 'Mỹ Tâm - Ca sĩ chính',
    titleSrc: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/titles/my-tam.png'
  },
  {
    src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/minh-thuý-2.png',
    alt: 'Minh Thuý',
    titleSrc: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/titles/minh-thuy.png'
  },
  {
    src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/minh-thuý-2.png',
    alt: 'Minh Thuý',
    titleSrc: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/titles/minh-thuy.png'
  },
  {
    src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/minh-thuý-2.png',
    alt: 'Minh Thuý',
    titleSrc: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/titles/minh-thuy.png'
  },
  {
    src: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/minh-thuý-2.png',
    alt: 'Minh Thuý',
    titleSrc: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/titles/minh-thuy.png'
  },
];
// Biến để test chỉ với Mỹ Tâm
const artistsDataMyTamOnly = [
  {
    src: '/assets/festival2025/vuon-concert-2025/images/artists-v2/mỹ-tâm.png',
    alt: 'Mỹ Tâm - Ca sĩ chính',
    titleSrc: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists-v2/titles/my-tam.png'
  },
];

const ArtistLineup = () => {
  // Tính toán responsive cho kích thước artist
  const getResponsiveSize = () => {
    if (typeof window !== 'undefined') {
      const width = window.innerWidth;
      if (width < 480) { // Mobile nhỏ
        return {
          artistWidth: 50, // 117 * 0.5
          mainArtistWidth: 120, // 280 * 0.5
          artistHeight: 175 // 349 * 0.5
        };
      } else if (width < 768) { // Mobile lớn / Tablet nhỏ
        return {
          artistWidth: 80, // 117 * 0.68
          mainArtistWidth: 190, // 280 * 0.68
          artistHeight: 237 // 349 * 0.68
        };
      } else if (width < 1024) { // Tablet
        return {
          artistWidth: 95, // 117 * 0.81
          mainArtistWidth: 227, // 280 * 0.81
          artistHeight: 283 // 349 * 0.81
        };
      } else { // Desktop
        return {
          artistWidth: 117, // Original
          mainArtistWidth: 280, // Original
          artistHeight: 349 // Original
        };
      }
    }
    // Default cho SSR
    return {
      artistWidth: 117,
      mainArtistWidth: 280,
      artistHeight: 349
    };
  };
  const sizes = getResponsiveSize();
  const ARTIST_CONTAINER_WIDTH = sizes.artistWidth;
  const SPACING_BETWEEN_ARTISTS = 0; // Khoảng cách giữa các ca sĩ

  return (
    // Container chính để tạo hình V
    <div className="relative w-full h-80 flex items-center justify-center" >
      {/* Container con để chứa các artist */}
      <div className="relative w-[3000px] h-72 flex items-center justify-center">
        <div className="relative w-full h-full">

        {artistsData.map((artist, index) => {
          const centerIndex = Math.floor(artistsData.length / 2);
          const distanceFromCenter = Math.abs(index - centerIndex);
          const isMainArtist = index === centerIndex;

          // Tính kích thước responsive cho ca sĩ
          const width = isMainArtist ? sizes.mainArtistWidth : ARTIST_CONTAINER_WIDTH;
          const height = isMainArtist ? 'auto' : sizes.artistHeight;

          // Tính vị trí X - xếp ca sĩ sát nhau theo hình V
          let xPosition;
          if (index < centerIndex) {
            // Bên trái: xếp từ trái sang phải, mỗi ca sĩ cách nhau ARTIST_CONTAINER_WIDTH + SPACING
            xPosition = -(centerIndex - index) * (ARTIST_CONTAINER_WIDTH + SPACING_BETWEEN_ARTISTS);
          } else if (index > centerIndex) {
            // Bên phải: xếp từ trái sang phải, mỗi ca sĩ cách nhau ARTIST_CONTAINER_WIDTH + SPACING
            xPosition = (index - centerIndex) * (ARTIST_CONTAINER_WIDTH + SPACING_BETWEEN_ARTISTS);
          } else {
            // Ca sĩ chính ở giữa
            xPosition = 0;
          }

          // Tính vị trí Y để tạo hình V - ca sĩ càng xa trung tâm càng cao lên
          let yOffset;
          if (isMainArtist) {
            yOffset = 0; // Ca sĩ chính ở vị trí chuẩn
          } else {
            // Các ca sĩ khác nâng cao dần theo khoảng cách từ trung tâm
            yOffset = -distanceFromCenter * 40; // Mỗi bước xa hơn thì cao hơn 40px
          }

          const animationDelay = isMainArtist ?
            artistsData.length * 100 :
            distanceFromCenter * 100;

          return (
            <div key={`artist-${index}`}>
              {/* Artist Container */}
              <div
                className={`absolute
                 animate-[slideInUp_0.8s_ease-out_forwards]
                 transition-transform duration-300 hover:scale-110
                 ${isMainArtist ? 'z-10' : 'z-0'}`}
                style={{
                  left: `calc(50% + ${xPosition - width/2}px)`,
                  top: `calc(50% + ${yOffset}px)`,
                  transform: `translateY(-50%)`,
                  animationDelay: `${animationDelay}ms`,
                  width: `${width}px`,
                  height: height === 'auto' ? 'auto' : `${height}px`,
                }}
              >
                {/* Tấm hình artist */}
                <Artist
                  src={artist.src}
                  alt={artist.alt}
                  titleSrc={artist.titleSrc}
                  height={height === 'auto' ? 'auto' : height}
                  width={width}
                />
              </div>
            </div>
          )
        })}

        </div>
      </div>
    </div>
  );
};

export default ArtistLineup;
